export const omitObjectKeys = <T>(object: T, keysToOmit: string[]) => {
  // eslint-disable-next-line @typescript-eslint/ban-ts-comment
  // @ts-ignore
  return Object.keys(object)
    .filter((key) => !keysToOmit.includes(key))
    .reduce((acc, key) => ({ ...acc, [key]: object[key as keyof T] }), {});
};
